'use client';

import { addFavorite, removeFavorite } from "@/app/actions/favorite";
import { Heart } from "@/components/private/heart";
import { useState } from "react";
import { getFavoriteOverride, setFavoriteOverride } from "./favorite-state";

export default function VideoFavoriteClient({
  active: initial,
  className: initialClassName,
  videoId,
}: {
  active: boolean,
  className: string,
  videoId: number
}) {
  const override = getFavoriteOverride(videoId);
  const [active, setActive,] = useState(override ?? initial);
  const [inProgress, setInProgress,] = useState(false);
  function onClick() {
    setInProgress(true);
    const newState = !active;
    const promise = newState ? addFavorite(videoId) : removeFavorite(videoId);
    setActive(newState);
    promise.then(() => {
      setFavoriteOverride(videoId, newState);
      setInProgress(false);
    }).catch(() => {
      setActive(active);
      setInProgress(false);
    });
  }

  const activeClass = active ? `active` : ``;
  const cursorClass = inProgress ? `cursor-progress` : ``;
  const className = [activeClass, cursorClass, initialClassName,].filter(Boolean).join(` `);

  return (
    <span
      className={className}
      onClick={() => !inProgress && onClick()}
    >
      <Heart />
      <span>{active ? `favorited` : `favorite`}</span>
    </span>
  );
}
